// @flow
import React from 'react';
import type { QuoteSequence } from 'store/modules/quotes';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';
import cx from 'classnames';
import './QuoteSequences.scss';

type QuoteSequenceItemProps = {
  sequence: QuoteSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(QuoteSequence[]),
  username: string,
  currentQuoteId: string,
};

const QuoteSequenceItem = ({ sequence, username, active }: QuoteSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/quotes/${url_slug}`;
  return (
    <FakeLink className={cx('QuoteSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const QuoteSequences = ({ sequences, username, currentQuoteId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="QuoteSequences">
      <div className="wrapper">
        <h3 className="title">다른 견적요청 둘러보기</h3>
        {sequences.map(s => (
          <QuoteSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentQuoteId}
          />
        ))}
      </div>
    </div>
  );
};

export default QuoteSequences;



// WEBPACK FOOTER //
// ./src/components/quote/QuoteSequences/QuoteSequences.js